import { Environment } from './environment.interface';

export const environment: Environment = {
  production: true,
  supabaseUrl: "https://ykimklpimdbuwxceyngs.supabase.co",
  supabaseKey: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlraW1rbHBpbWRidXd4Y2V5bmdzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDM4NTExNTgsImV4cCI6MjA1OTQyNzE1OH0.-UJuUYNWv_WV8SnR3gX8nCVrf4pKGv-QtbFI-tfgcHA", // Anon key is safe for client-side
  supabaseServiceRoleKey: "", // Remove from client-side - will be set via server environment variables
  openaiApiKey: "", // Remove from client-side - will be set via server environment variables  
  apiUrl: "https://ykimklpimdbuwxceyngs.supabase.co/functions/v1/auth-api",
  turnstileSiteKey: "0x4AAAAAABafpQy1C9Fv9yX3", // Public key, safe for client-side
  posthogKey: "phc_2iaFc2eWvfDFwo5kA9tPgFZR6GBx6IIMgf1ay2dFTQ5", // Public key, safe for client-side
  posthogHost: "https://eu.i.posthog.com",
  stripePublishableKey: "pk_live_51RCP4YGv9e3NMD5jGwMFIn85wIuegcCF5hYU26lc0cVIGiqFKV3GuHuVfIg05kzYsGnqdTDo8zeejd7JtbQR1QkS00GWXoe8h7", // Live publishable key
};
